<template>
  <v-form ref="form" v-model="validacion" lazy-validation
    ><!--ver para que el lazy validation xD -->
    <v-card>
      <v-container>
        <v-layout>
          <!-- SECCION 1 -->
          <v-flex xs12 md4>
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fecha_nacimiento"
                  label="Fecha Nacimiento"
                  :box="isDisabled"
                  :readonly="isDisabled"
                  prepend-icon="event"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fecha_nacimiento"
                @input="menu1 = false"
                no-title
                locale="es"
                first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
            <v-text-field
              v-model="rut"
              label="Rut"
              counter="10"
              maxlength="10"
              :error-messages="rutErrors"
              :box="isDisabledRut"
              :readonly="isDisabledRut"
              @input="dvRut()"
              @focusout="checkRut"
              @blur="tipeView == 'crear' ? $v.rut.$touch() : null"
            ></v-text-field>
            <v-text-field
              v-model="nombre"
              label="Nombre"
              :error-messages="nombreErrors"
              :box="isDisabled"
              :readonly="isDisabled"
              @input="$v.nombre.$touch()"
              @blur="tipeView == 'crear' ? $v.nombre.$touch() : null"
            ></v-text-field>
            <v-text-field
              v-model="apellido1"
              label="Primer Apellido"
              :error-messages="apellidoErrors"
              :box="isDisabled"
              :readonly="isDisabled"
              @input="$v.apellido1.$touch()"
              @blur="tipeView == 'crear' ? $v.apellido1.$touch() : null"
            ></v-text-field>
            <v-text-field
              v-model="apellido"
              label="Segundo Apellido"
              :error-messages="apellidoErrors"
              :box="isDisabled"
              :readonly="isDisabled"
              @input="$v.apellido.$touch()"
              @blur="tipeView == 'crear' ? $v.apellido.$touch() : null"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1></v-flex>
          <v-flex xs12 md4>
            <v-select
              v-model="regionValue"
              :error-messages="selectErrors"
              item-text="nombre"
              item-value="code"
              :items="regionesSelect"
              label="Region"
              :box="isDisabledSel"
              :readonly="isDisabledSel"
              @change="comunaFiltro()"
              @input="$v.regionValue.$touch()"
              @blur="tipeView == 'crear' ? $v.regionValue.$touch() : null"
            ></v-select>
            <v-select
              v-model="comunaValue"
              :error-messages="selectErrors"
              :items="comunasSelect"
              item-text="nombre"
              item-value="code"
              label="Comuna"
              :box="isDisabledSel"
              :readonly="isDisabledSel"
              @input="$v.comunaValue.$touch()"
              @blur="
                tipeView == 'crear' || tipeView == 'consulta'
                  ? $v.comunaValue.$touch()
                  : null
              "
            ></v-select>
            <v-text-field
              v-model="email"
              :error-messages="emailErrors"
              label="E-mail"
              :box="isDisabledSel"
              :readonly="isDisabledSel"
              @input="$v.email.$touch()"
              @blur="tipeView == 'crear' ? $v.email.$touch() : null"
            ></v-text-field>
            <v-text-field
              v-model="fono"
              :error-messages="fonoErrors"
              label="Fono"
              :box="isDisabled"
              :readonly="isDisabled"
              @input="$v.fono.$touch()"
              @blur="tipeView == 'crear' ? $v.fono.$touch() : null"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1></v-flex>
          <v-flex xs12 md4>
            <v-select
              v-model="rolesValue"
              :error-messages="selectErrors"
              :items="rolesSelect"
              label="Rol"
              item-text="nombre"
              item-value="code"
              :box="isDisabledSel"
              :readonly="isDisabledSel"
              data-vv-name="listaRoles"
              @input="$v.rolesValue.$touch()"
              @blur="tipeView == 'crear' ? $v.rolesValue.$touch() : null"
            ></v-select>
            <v-select
              v-model="forma_capValue"
              :items="matricula"
              item-text="descripcion"
              item-value="id"
              label="Tipo Matricula"
              :box="isDisabledSel"
              :readonly="isDisabledSel"
            ></v-select>
            <v-select
              v-model="perfilValue"
              :error-messages="selectErrors"
              :items="perfilSelect"
              label="Perfil"
              :box="isDisabledSel"
              :readonly="isDisabledSel"
              data-vv-name="listaRc"
              @input="$v.perfilValue.$touch()"
              @blur="tipeView == 'crear' ? $v.perfilValue.$touch() : null"
            ></v-select>
            <!-- <v-text-field
            v-if="tipeView == 'consulta' || (tab== 'Capacitacion' || tab== 'Asignacion')   ? false : true"
            v-model="asuntoDocumento"
            label="Asunto Documento"
              :box="isDisabledselect"
              :readonly="isDisabledselect"
            ></v-text-field>

            <v-toolbar-title
              v-if="
                tipeView == 'consulta' ||
                tab == 'Capacitacion' ||
                tab == 'Asignacion'
                  ? false
                  : true
              "
              class="indigo--text"
              >Adjuntar Documento</v-toolbar-title
            >
            <data-adjunto
              :documentoId="id"
              :tipeView="tipeView"
              :tipeArchive="tipeArchive"
            ></data-adjunto> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <!-- SECCION 2 -->
    <br />
    <v-card
      v-if="
        (tab == 'Capacitacion' || tab == 'Contratacion') &&
        (this.tipeView == 'modifica' || this.tipeView == 'consulta') &&
        (usuarioLoggedTipe == 'PROVEEDOR' ||
          usuarioLoggedTipe == 'ADMINISTRADOR')
      "
    >
      <v-container>
        <v-flex xs4>
          <v-card> Centro Seleccionado: {{ codeCentro }} </v-card>
        </v-flex>
        <v-layout>
          <v-flex xs12 md4>
            <!-- ================================SECCION 1 -->
            <v-btn
              v-if="
                tab == 'Capacitacion' &&
                this.tipeView == 'modifica' &&
                (usuarioLoggedTipe == 'PROVEEDOR' ||
                  usuarioLoggedTipe == 'ADMINISTRADOR')
              "
              color="primary"
              dark
              class="mb-2"
              @click="openDeleteDialog()"
            >
              Seleccionar Centro
            </v-btn>
            <v-select
              v-model="rutRelatoresValue"
              :error-messages="resultadoSelect"
              :items="rutRelatoresSelect"
              label="Rut relator"
              item-text="rut"
              item-value="code"
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              @input="$v.rutRelatoresValue.$touch()"
              @blur="
                tipeView == 'modifica' ? $v.rutRelatoresValue.$touch() : null
              "
            ></v-select>
            <v-select
              v-model="resultadoTecValue"
              :error-messages="resultadoSelect"
              :items="resultadoTecSelect"
              label="Resultado Tec. Capacitacion"
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaRc"
              @input="$v.resultadoTecValue.$touch()"
              @blur="
                tipeView == 'modifica' ? $v.resultadoTecValue.$touch() : null
              "
            ></v-select>
            <v-select
              v-model="complementarioValue"
              :error-messages="resultadoSelect"
              :items="complementarioSelect"
              label="Resultado Medio complementario"
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaRc"
              @input="$v.resultadoTecValue.$touch()"
              @blur="
                tipeView == 'modifica' ? $v.resultadoTecValue.$touch() : null
              "
            ></v-select>
            <v-text-field
              v-model="puntajeParcial"
              :error-messages="puntajeErrors"
              label="Puntaje parcial capacitado"
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              @input="$v.puntajeParcial.$touch()"
              @blur="tipeView == 'modifica' ? $v.puntajeParcial.$touch() : null"
            ></v-text-field>
            <v-text-field
              v-model="puntajeDds"
              :error-messages="puntajeErrors"
              label="Puntaje DDS"
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              @input="$v.puntajeDds.$touch()"
              @blur="tipeView == 'modifica' ? $v.puntajeDds.$touch() : null"
            ></v-text-field>
            <v-text-field
              v-model="puntajeDvp"
              :error-messages="puntajeErrors"
              label="Puntaje DVP"
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              @input="$v.puntajeDvp.$touch()"
              @blur="tipeView == 'modifica' ? $v.puntajeDvp.$touch() : null"
            ></v-text-field>
            <v-text-field
              v-model="puntajeDvt"
              :error-messages="puntajeErrors"
              label="Puntaje DVT"
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              @input="$v.puntajeDvt.$touch()"
              @blur="tipeView == 'modifica' ? $v.puntajeDvt.$touch() : null"
            ></v-text-field>
            <v-select
              v-if="
                documento.rolCapId !== undefined &&
                documento.rolCapId != null &&
                documento.rolCapId.descripcion ==
                  'Examinador DS Visual-Auditivo' &&
                tab == 'Capacitacion' &&
                (usuarioLoggedTipe == 'PROVEEDOR' ||
                  usuarioLoggedTipe == 'ADMINISTRADOR')
              "
              v-model="lschCapValue"
              :error-messages="ldErrors"
              :items="lschCapSelect"
              label="Lsch Capacitado"
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaRc"
              @input="$v.lschCapValue.$touch()"
              @blur="tipeView == 'modifica' ? $v.lschCapValue.$touch() : null"
            ></v-select>
            <v-select
              v-if="
                documento.rolCapId !== undefined &&
                documento.rolCapId != null &&
                documento.rolCapId.descripcion ==
                  'Examinador DS Visual-Auditivo' &&
                tab == 'Capacitacion' &&
                (usuarioLoggedTipe == 'PROVEEDOR' ||
                  usuarioLoggedTipe == 'ADMINISTRADOR')
              "
              v-model="lengOralCapValue"
              :error-messages="ldErrors"
              :items="lengOralCapSelect"
              label="Lenguaje oral capacitado"
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaRc"
              @input="$v.lengOralCapValue.$touch()"
              @blur="
                tipeView == 'modifica' ? $v.lengOralCapValue.$touch() : null
              "
            ></v-select>
            <v-select
              v-if="
                documento.rolCapId !== undefined &&
                documento.rolCapId != null &&
                (documento.rolCapId.descripcion ==
                  'Examinador DS Visual Parcial' ||
                  documento.rolCapId.descripcion ==
                    'Examinador DS Visual Total') &&
                tab == 'Capacitacion' &&
                (usuarioLoggedTipe == 'PROVEEDOR' ||
                  usuarioLoggedTipe == 'ADMINISTRADOR')
              "
              v-model="sistemaBrailleValue"
              :error-messages="ldErrors"
              :items="sistemaBrailleSelect"
              label="Sistema braille"
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaRc"
              @input="$v.sistemaBrailleValue.$touch()"
              @blur="
                tipeView == 'modifica' ? $v.sistemaBrailleValue.$touch() : null
              "
            ></v-select>
            <v-select
              v-if="
                documento.rolCapId !== undefined &&
                documento.rolCapId != null &&
                (documento.rolCapId.descripcion ==
                  'Examinador DS Visual Parcial' ||
                  documento.rolCapId.descripcion ==
                    'Examinador DS Visual Total') &&
                tab == 'Capacitacion' &&
                (usuarioLoggedTipe == 'PROVEEDOR' ||
                  usuarioLoggedTipe == 'ADMINISTRADOR')
              "
              v-model="dvpCapacitadoValue"
              :items="dvpCapacitadoSelect"
              label="DVP Capacitado"
              :error-messages="ldErrors"
              @input="$v.dvpCapacitadoValue.$touch()"
              @blur="
                tipeView == 'modifica' ? $v.dvpCapacitadoValue.$touch() : null
              "
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaRc"
            ></v-select>
            <v-select
              v-model="resultadoCapValue"
              :items="resultadoCapSelect"
              label="Resultado Capacitación"
              :error-messages="ldErrors"
              @input="$v.resultadoCapValue.$touch()"
              @blur="
                tipeView == 'modifica' ? $v.resultadoCapValue.$touch() : null
              "
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaRc"
            ></v-select>
          </v-flex>
          <v-flex xs12 md1></v-flex>
          <v-flex md4>
            <!-- ================================SECCION 2 -->
            <!-- <v-text-field
                v-model="imagenTec"
                 :error-messages="imgErrors"
                label="Imagen TEC"
                :box="isDisabledCap"
              :readonly="isDisabledCap"
              @input="$v.imagenTec.$touch()"
              @blur="tipeView =='modifica' ? $v.imagenTec.$touch() : null"
              ></v-text-field> -->
            <!-- ADJUNTOS -->
            <!-- <imagen-tec
                :key="imagenTec"               
                :tipeArchive="tipeArchive"
              ></imagen-tec> -->
            <v-select
              v-model="resultadoTecNuevoValue"
              :items="resultadoTecNuevoSelect"
              :error-messages="imgErrors"
              @input="$v.resultadoTecNuevoValue.$touch()"
              @blur="
                tipeView == 'modifica'
                  ? $v.resultadoTecNuevoValue.$touch()
                  : null
              "
              label="Resultado TEC"
              item-text="descripcion"
              item-value="id"
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaResultadoTec"
            ></v-select>
            <v-select
              v-model="resultadoTecNuevoValue"
              :items="resultadoTecDosSelect"
              label="Resultado TEC2"
              item-text="descripcion"
              item-value="id"
              :error-messages="imgErrors"
              @input="$v.resultadoTecNuevoValue.$touch()"
              @blur="
                tipeView == 'modifica'
                  ? $v.resultadoTecNuevoValue.$touch()
                  : null
              "
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaResultadoTec2"
            ></v-select>
            <!-- <v-text-field
                v-model="imagenTec2"
                label="Imagen TEC2"
                :error-messages="imgErrors" 
               @input="$v.imagenTec2.$touch()"
              @blur="tipeView =='modifica' ? $v.imagenTec2.$touch() : null"
                :box="isDisabledCap"
              :readonly="isDisabledCap"
              ></v-text-field> -->
            <!-- ADJUNTOS -->
            <!-- <imagen-tec-dos
                :key="imagenTecDos"               
                :tipeArchive="tipeArchive"
              ></imagen-tec-dos> -->
            <v-select
              v-model="resultadoParValue"
              :items="resultadoParSelect"
              label="Resultado PAR"
              item-text="descripcion"
              item-value="id"
              :error-messages="imgErrors"
              @input="$v.resultadoParValue.$touch()"
              @blur="
                tipeView == 'modifica' ? $v.resultadoParValue.$touch() : null
              "
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaResultadoPar"
            ></v-select>
            <!-- <v-text-field
                v-model="imagenPar"
                label="Imagen PAR"
                :error-messages="imgErrors" 
               @input="$v.imagenPar.$touch()"
              @blur="tipeView =='modifica' ? $v.imagenPar.$touch() : null"
                :box="isDisabledCap"
              :readonly="isDisabledCap"
              ></v-text-field> -->
            <!-- ADJUNTO -->
            <!-- <imagen-par
                :key="imagenPar"               
                :tipeArchive="tipeArchive"
              ></imagen-par> -->

            <v-select
              v-model="resultadoPar2Value"
              :items="resultadoPar2Select"
              label="Resultado PAR2"
              item-text="descripcion"
              item-value="id"
              :error-messages="imgErrors"
              @input="$v.resultadoPar2Value.$touch()"
              @blur="
                tipeView == 'modifica' ? $v.resultadoPar2Value.$touch() : null
              "
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaResultadoPar2"
            ></v-select>
            <!-- <v-text-field
                v-model="imagenPar2"
                label="Imagen PAR2"
                :error-messages="imgErrors" 
               @input="$v.imagenPar2.$touch()"
              @blur="tipeView =='modifica' ? $v.imagenPar2.$touch() : null"
                :box="isDisabledCap"
                :readonly="isDisabledCap"
              ></v-text-field> -->
            <!-- <imagen-par-dos
                :key="imagenParDos"               
                :tipeArchive="tipeArchive"
              ></imagen-par-dos> -->
            <v-select
              v-model="resultadoPardsDaValue"
              :items="resultadoPardsDaSelect"
              label="Resultado PARDS DA"
              item-text="descripcion"
              item-value="id"
              :error-messages="imgErrors"
              @input="$v.resultadoPardsDaValue.$touch()"
              @blur="
                tipeView == 'modifica'
                  ? $v.resultadoPardsDaValue.$touch()
                  : null
              "
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaResultadoPardsDa"
            ></v-select>
            <v-select
              v-model="resultadoPardsDvpValue"
              :items="resultadoPardsDvpSelect"
              label="Resultado PARDS DVP"
              item-text="descripcion"
              item-value="id"
              :error-messages="imgErrors"
              @input="$v.resultadoPardsDvpValue.$touch()"
              @blur="
                tipeView == 'modifica'
                  ? $v.resultadoPardsDvpValue.$touch()
                  : null
              "
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaResultadoPardsDvp"
            ></v-select>
          </v-flex>
          <v-flex xs12 md1></v-flex>
          <v-flex md4>
            <!-- ================================SECCION 3 -->
            <v-select
              v-model="resultadoPardsDvtValue"
              :items="resultadoPardsDvtSelect"
              label="Resultado PARDS DVT"
              item-text="descripcion"
              item-value="id"
              :error-messages="imgErrors"
              @input="$v.resultadoPardsDvtValue.$touch()"
              @blur="
                tipeView == 'modifica'
                  ? $v.resultadoPardsDvtValue.$touch()
                  : null
              "
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaResultadoPardsDvt"
            ></v-select>
            <!-- <v-text-field
                v-model="imagenPards"
                label="Imagen PARDS"
                :error-messages="imgErrors" 
               @input="$v.imagenPards.$touch()"
              @blur="tipeView =='modifica' ? $v.imagenPards.$touch() : null"
                :box="isDisabledCap"
              :readonly="isDisabledCap"
              ></v-text-field> -->
            <!-- Adjunto -->
            <!-- <imagen-pards
                :key="imagenPards"               
                :tipeArchive="tipeArchive"
              ></imagen-pards> -->
            <v-select
              v-model="resultadoDsdaValue"
              :items="resultadoDsdaSelect"
              label="Resultado DSDA"
              item-text="descripcion"
              item-value="id"
              :error-messages="imgErrors"
              @input="$v.resultadoDsdaValue.$touch()"
              @blur="
                tipeView == 'modifica' ? $v.resultadoDsdaValue.$touch() : null
              "
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaResultadoDsda"
            ></v-select>
            <!-- <v-text-field
                v-model="imagenDsda"
                label="Imagen DSDA"
                :error-messages="imgErrors" 
               @input="$v.imagenDsda.$touch()"
              @blur="tipeView =='modifica' ? $v.imagenDsda.$touch() : null"
                :box="isDisabledCap"
              :readonly="isDisabledCap"
              ></v-text-field> -->
            <!-- ADJUNTOS -->
            <!-- <imagen-dsda
                :key="imagenDsda"               
                :tipeArchive="tipeArchive"
              ></imagen-dsda> -->
            <v-select
              v-model="resultadoDsdaLschValue"
              :items="resultadoDsdaLschSelect"
              label="Resultado DSDA LSCH"
              item-text="descripcion"
              item-value="id"
              :error-messages="imgErrors"
              @input="$v.resultadoDsdaLschValue.$touch()"
              @blur="
                tipeView == 'modifica'
                  ? $v.resultadoDsdaLschValue.$touch()
                  : null
              "
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaResultadoDsdaLsdh"
            ></v-select>
            <!-- <v-text-field
                v-model="imagenDsdaLsch"
                label="Imagen DSDA LSCH"
                :error-messages="imgErrors" 
               @input="$v.imagenDsdaLsch.$touch()"
              @blur="tipeView =='modifica' ? $v.imagenDsdaLsch.$touch() : null"
                :box="isDisabledCap"
              :readonly="isDisabledCap"
              ></v-text-field> -->
            <!-- <imagen-dsda-lsch
                :key="imagenTec"               
                :tipeArchive="tipeArchive"
              ></imagen-dsda-lsch> -->
            <v-select
              v-model="resultadoDvpValue"
              :items="resultadoDvpSelect"
              label="Resultado DVP"
              item-text="descripcion"
              item-value="id"
              :error-messages="imgErrors"
              @input="$v.resultadoDvpValue.$touch()"
              @blur="
                tipeView == 'modifica' ? $v.resultadoDvpValue.$touch() : null
              "
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaResultadoDvp"
            ></v-select>
            <!-- <v-text-field
                v-model="imagenDvp"
                label="Imagen DVP"
                :error-messages="imgErrors" 
               @input="$v.imagenDvp.$touch()"
              @blur="tipeView =='modifica' ? $v.imagenDvp.$touch() : null"
                :box="isDisabledCap"
              :readonly="isDisabledCap"
              ></v-text-field> -->
            <!-- <imagen-dvp
                :key="imagenTec"               
                :tipeArchive="tipeArchive"
              ></imagen-dvp> -->
            <v-select
              v-model="resultadoDvtValue"
              :items="resultadoDvtSelect"
              label="Resultado DVT"
              item-text="descripcion"
              item-value="id"
              :error-messages="imgErrors"
              @input="$v.resultadoDvtValue.$touch()"
              @blur="
                tipeView == 'modifica' ? $v.resultadoDvtValue.$touch() : null
              "
              :box="isDisabledCap"
              :readonly="isDisabledCap"
              data-vv-name="listaResultadoDvt"
            ></v-select>
            <!-- <v-text-field
                v-model="imagenDvt"
                label="Imagen DVT"
                :error-messages="imgErrors" 
               @input="$v.imagenDvt.$touch()"
              @blur="tipeView =='modifica' ? $v.imagenDvt.$touch() : null"
                :box="isDisabledCap"
              :readonly="isDisabledCap"
              ></v-text-field>  
              <imagen-dvt
                :key="imagenTec"               
                :tipeArchive="tipeArchive"
              ></imagen-dvt>             -->
          </v-flex>
          <v-dialog v-model="dialogGrid" persistent max-width="800">
            <v-card>
              <v-card-title class="headline">Centros</v-card-title>
              <v-card-text>
                <v-layout justify-center>
                  <v-flex xs12 md4>
                    <v-select
                      v-model="regionCentroValue"
                      :items="regionCentroSelect"
                      label="Region"
                      data-vv-name="listaRegiones"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-select
                      v-model="comunaCentroValue"
                      :items="comunaCentroSelect"
                      label="Comuna"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-select
                      v-model="estadoValue"
                      :items="estadoSelect"
                      label="Estado"
                    ></v-select>
                  </v-flex>
                  <v-btn
                    fab
                    dark
                    color="teal"
                    title="Filtrar detalle"
                    @click="filterCenter()"
                  >
                    <v-icon dark>filter_list</v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    dark
                    color="red darken-4"
                    title="Limpiar filtros"
                    @click="clear()"
                  >
                    <v-icon dark>clear_all</v-icon>
                  </v-btn>
                </v-layout>
                <v-flex lg12>
                  <v-spacer></v-spacer>
                  <v-data-table
                    :headers="headers"
                    :items="itemsCentro"
                    :rows-per-page-items="rowsPerPageItems"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-left">{{ props.item.codCentro }}</td>
                      <td class="text-xs-left">
                        {{ props.item.region.nombre }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.comuna.nombre }}
                      </td>
                      <td class="text-xs-left">{{ props.item.direccion }}</td>
                      <td class="text-xs-left">
                        {{
                          props.item.estadoCentro !== undefined &&
                          props.item.estadoCentro != null
                            ? props.item.estadoCentro.descripcion
                            : "-"
                        }}
                      </td>
                      <div class="text-xs-center">
                        <td>
                          <v-btn
                            class="text-xs-center"
                            depressed
                            outline
                            icon
                            fab
                            dark
                            color="blue darken-4"
                            small
                            title="Elegir Centro"
                            @click="
                              openSeleccion(props.item.id, props.item.codCentro)
                            "
                          >
                            <v-icon>check_circle</v-icon>
                          </v-btn>
                        </td>
                      </div>
                    </template>
                  </v-data-table>
                  <v-card-actions class="pb-3">
                    <v-spacer></v-spacer>
                    <div class="text-xs-center">
                      <td>
                        <template>
                          <v-btn
                            class="btn-sigas"
                            depressed
                            outline
                            icon
                            fab
                            dark
                            color="blue darken-4"
                            small
                          >
                            <v-icon>check_circle</v-icon> </v-btn
                          >Elegir Centro
                        </template>
                      </td>
                    </div>
                  </v-card-actions>
                </v-flex>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat @click="dialogGrid = false"
                  >Cerrar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-container>
    </v-card>
    <br />
    <v-card
      v-if="
        tab == 'Reclutados' &&
        (tipeView == 'consulta' || tipeView == 'modifica')
          ? true
          : false
      "
    >
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text"
          >Descargar Documentos</v-toolbar-title
        >
      </v-toolbar>
      <v-card-text>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers2"
            :items="itemsDocs"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.asunto }}</td>
              <td class="text-xs-left">{{ props.item.fecha_creacion }}</td>
              <td class="text-xs-left">{{ props.item.filename }}</td>
              <div class="text-xs-center">
                <td>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                    title="Descargar documento"
                    @click="downloadFile(props.item.id, props.item.filename)"
                  >
                    <v-icon>cloud_download</v-icon>
                  </v-btn>
                </td>
              </div>
            </template>
          </v-data-table>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-flex>
      </v-card-text>
    </v-card>
    <br />
    <v-card
      v-if="
        tab == 'Asignacion' &&
        (tipeView == 'consulta' || tipeView == 'modifica')
          ? true
          : false
      "
    >
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text">Asignación</v-toolbar-title>
      </v-toolbar>
      <grid-asignacion-data
        :key="gridDocumento"
        :id="id"
        :rut="rut"
        :tipeView="tipeView"
      ></grid-asignacion-data>
    </v-card>
    <v-card-actions class="pb-3">
      <v-btn
        v-if="tipeView == 'consulta' ? false : true"
        color="primary"
        dark
        class="mb-2"
        @click="save()"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
import { error } from "util";
import GridAsignacionData from "@/modules/aplicacion/views/seleccion/asignacion/AsignacionData.vue";
import ImagenTec from "@/components/AdjuntoData.vue";
import ImagenTecDos from "@/components/AdjuntoData.vue";
import ImagenPar from "@/components/AdjuntoData.vue";
import ImagenParDos from "@/components/AdjuntoData.vue";
import ImagenDsda from "@/components/AdjuntoData.vue";
import ImagenDsdaLsch from "@/components/AdjuntoData.vue";
import ImagenDvp from "@/components/AdjuntoData.vue";
import ImagenDvt from "@/components/AdjuntoData.vue";

export default {
  name: "candidatos-data",
  components: {
    ImagenTec,
    ImagenTecDos,
    ImagenPar,
    ImagenParDos,
    ImagenDsda,
    ImagenDsdaLsch,
    ImagenDvp,
    ImagenDvt,
    GridAsignacionData,
  },
  mixins: [misMixins, validationMixin],
  props: {
    tipeView: "",
  },
  data() {
    return {
      gridDocumento: 20,
      menu1: false,
      menu2: false,
      menu3: false,
      dialogGrid: false,
      filter: false,
      selectRol: false,
      itemsDocs: [],
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        {
          text: "Cod-Centro",
          align: "left",
          sortable: false,
          value: "codCentro",
        },
        { text: "Region", sortable: false, value: "region" },
        { text: "Comuna", sortable: false, value: "comuna" },
        { text: "Direccion", sortable: false, value: "direccion" },
        { text: "Estado", sortable: false, value: "estado" },
        {
          text: "Accion",
          sortable: false,
          value: "accion",
        },
      ],
      headers2: [
        { text: "Asunto", sortable: false, value: "asunto" },
        { text: "Fecha de creacion", sortable: false, value: "fecha_creacion" },
        { text: "Filename", sortable: false, value: "filename" },
        {
          text: "Descargar documentos",
          sortable: false,
          value: "",
        },
      ],
      id: "",
      idCentros: "",
      codeCentro: "",
      asuntoDocumento: "",
      fecha_nacimiento: "",
      fecha_capacitacion: "",
      allowSpaces: false,
      itemsCentro: [],
      codigo: "",
      contratoId: "",
      user: "",
      username: "",
      nombre: "",
      apellido1: "",
      apellido: "",
      rut: "",
      rutRelatoresValue: "",
      rutRelatoresSelect: [],
      rutSupervisorValue: "",
      rutSupervisorSelect: [],
      documento: "",
      idCandidatos: "",
      centrosSelect: [],
      centrosValue: "",
      validacion: false,
      exist: "",
      dv: "",
      regionValue: "",
      comunaValue: "",
      regionesSelect: [],
      comunasSelect: [],
      regionCentroValue: "",
      regionCentroSelect: [],
      comunaCentroValue: "",
      comunaCentroSelect: [],
      estadoValue: "",
      estadoSelect: [],
      fono: "",
      email: "",
      rolesValue: "",
      rolesSelect: [],
      forma_capValue: "",
      forma_capSelect: [],
      usuarioLoggedTipe: "",
      proceso: "",
      tab: "",
      resultadoTecValue: "",
      resultadoTecSelect: [],
      resultadoCapValue: "",
      resultadoCapSelect: [],
      complementarioValue: "",
      complementarioSelect: [],
      centrosSelect: [],
      centrosValue: "",
      rutRelator: "",
      dvpCapacitadoValue: "",
      dvpCapacitadoSelect: [],
      sistemaBrailleValue: "",
      sistemaBrailleSelect: [],
      lengOralCapValue: "",
      lengOralCapSelect: [],
      lschCapValue: null,
      lschCapSelect: [],
      puntajeDvt: "",
      puntajeParcial: "",
      puntajeDds: "",
      puntajeDvp: "",
      tipeArchive: "",
      base64Value: "",
      filenameValue: "",
      codigo: "",
      idRol: "",
      // =============================campos nuevos
      resultadoOpciones: [
        {
          id: "APROBADO",
          descripcion: "APROBADO",
        },
        {
          id: "RECHAZADO",
          descripcion: "RECHAZADO",
        },
      ],
      matricula: [
        {
          id: 1,
          descripcion: "Presencial",
        },
        {
          id: 2,
          descripcion: "Abreviada",
        },
        {
          id: 3,
          descripcion: "B-Learning",
        },
      ],
      imagenTec: "",
      resultadoTecNuevoValue: "",
      resultadoTecNuevoSelect: [],
      resultadoTecDosNuevoValue: "",
      resultadoTecDosSelect: [],
      imagenTec2: "",
      resultadoParValue: "",
      resultadoParSelect: [],
      imagenPar: "",
      resultadoPar2Value: "",
      resultadoPar2Select: [],
      imagenPar2: "",
      resultadoPardsDaValue: "",
      resultadoPardsDaSelect: [],
      resultadoPardsDvpValue: "",
      resultadoPardsDvpSelect: [],
      resultadoPardsDvtValue: "",
      resultadoPardsDvtSelect: [],
      imagenPards: "",
      resultadoDsdaValue: "",
      resultadoDsdaSelect: [],
      imagenDsda: "",
      resultadoDsdaLschValue: "",
      resultadoDsdaLschSelect: [],
      imagenDsdaLsch: "",
      resultadoDvpValue: "",
      resultadoDvpSelect: [],
      imagenDvp: "",
      resultadoDvtValue: "",
      resultadoDvtSelect: [],
      imagenDvt: "",
      perfilValue: "",
      perfilSelect: [],
    };
  },

  validations: {
    nombre: { required },
    apellido: { required },
    apellido1: { required },
    rut: { required },
    email: { required, email },
    fono: { required },
    regionValue: { required },
    comunaValue: { required },
    rolValue: { required },
    forma_capValue: { required },
    rutRelatoresValue: { required },
    resultadoTecValue: { required },
    complementarioValue: { required },
    puntajeParcial: { required },
    puntajeDds: { required },
    puntajeDvp: { required },
    puntajeDvt: { required },
    lschCapValue: { required },
    lengOralCapValue: { required },
    sistemaBrailleValue: { required },
    dvpCapacitadoValue: { required },
    resultadoCapValue: { required },
    imagenTec: { required },
    resultadoTecNuevoValue: { required },
    resultadoTecNuevoValue: { required },
    imagenTec2: { required },
    resultadoParValue: { required },
    imagenPar: { required },
    resultadoPar2Value: { required },
    imagenPar2: { required },
    resultadoPardsDaValue: { required },
    resultadoPardsDvpValue: { required },
    resultadoPardsDvtValue: { required },
    imagenPards: { required },
    resultadoDsdaValue: { required },
    imagenDsda: { required },
    resultadoDsdaLschValue: { required },
    imagenDsdaLsch: { required },
    resultadoDvpValue: { required },
    imagenDvp: { required },
    resultadoDvtValue: { required },
    imagenDvt: { required },
    perfilValue: { required },
  },

  created() {
    this.tipeArchive = "*";
    this.id = this.$route.params.id;
    this.user = this.$store.getters.userLogged.tipo;
    if (this.tipeView === undefined) {
      this.tipeView = this.$route.params.tipeView;
    }
    if (this.tipeView == "consulta") {
      this.loadData();
    }
    if (this.tipeView == "crear") {
      this.loadDataComuna();
      this.loadDataRoles();
      //this.loadTipoSelect();
      this.loadOpcionesFijas();
      this.loadSelect();
    }
    if (this.tipeView == "modifica") {
      this.loadData();
    }

    this.loadDataCentros();
    this.loadDataDocumentos(this.id);
  },
  mounted() {
    this.tab = this.$store.getters.subTabSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.contratoId = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
    this.proceso = this.$store.getters.subProTabSelectedStored;
  },
  computed: {
    rutErrors() {
      const errors = [];
      if (!this.$v.rut.$dirty) return errors;
      !this.$v.rut.required && errors.push("Rut es obligatorio.");
      return errors;
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre es obligatorio.");
      return errors;
    },
    apellidoErrors() {
      const errors = [];
      if (!this.$v.apellido.$dirty) return errors;
      !this.$v.apellido.required && errors.push("Apellido es obligatorio.");
      return errors;
    },
    fonoErrors() {
      const errors = [];
      if (!this.$v.fono.$dirty) return errors;
      !this.$v.fono.required && errors.push("Nombre es requerido.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail es requerido");
      if (this.exist) {
        errors.push("E-mail ya existe");
      }
      return errors;
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.regionValue.$dirty) return errors;
      !this.$v.regionValue.required && errors.push("Item is required");
      return errors;
      if (!this.$v.comunaValue.$dirty) return errors;
      !this.$v.comunaValue.required && errors.push("Item is required");
      return errors;
    },
    //  relatorErrors() {
    //   const errors = [];
    //   if (!this.$v.rutRelatoresValue.$dirty) return errors;
    //   !this.$v.rutRelatoresValue.required && errors.push("Item es requerido");
    //   return errors;
    // },
    puntajeErrors() {
      const errors = [];
      if (!this.$v.puntajeParcial.$dirty) return errors;
      !this.$v.puntajeParcial.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.puntajeDds.$dirty) return errors;
      !this.$v.puntajeDds.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.puntajeDvp.$dirty) return errors;
      !this.$v.puntajeDvp.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.puntajeDvt.$dirty) return errors;
      !this.$v.puntajeDvt.required && errors.push("Item es requerido");
      return errors;
    },
    resultadoSelect() {
      const errors = [];
      if (!this.$v.resultadoTecValue.$dirty) return errors;
      !this.$v.resultadoTecValue.required && errors.push("Item es requerido");
      return errors;
      // if (!this.$v.rutRelatoresValue.$dirty) return errors;
      // !this.$v.rutRelatoresValue.required && errors.push("Item es requerido");
      // return errors;

      if (!this.$v.complementarioValue.$dirty) return errors;
      !this.$v.complementarioValue.required && errors.push("Item es requerido");
      return errors;
    },
    ldErrors() {
      const errors = [];
      if (!this.$v.sistemaBrailleValue.$dirty) return errors;
      !this.$v.sistemaBrailleValue.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.lschCapValue.$dirty) return errors;
      !this.$v.lschCapValue.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.lengOralCapValue.$dirty) return errors;
      !this.$v.lengOralCapValue.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.dvpCapacitadoValue.$dirty) return errors;
      !this.$v.dvpCapacitadoValue.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.resultadoCapValue.$dirty) return errors;
      !this.$v.resultadoCapValue.required && errors.push("Item es requerido");
      return errors;
    },
    imgErrors() {
      const errors = [];
      if (!this.$v.imagenTec.$dirty) return errors;
      !this.$v.imagenTec.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.resultadoTecNuevoValue.$dirty) return errors;
      !this.$v.resultadoTecNuevoValue.required &&
        errors.push("Item es requerido");
      return errors;
      if (!this.$v.resultadoTecNuevoValue.$dirty) return errors;
      !this.$v.resultadoTecNuevoValue.required &&
        errors.push("Item es requerido");
      return errors;
      if (!this.$v.imagenTec2.$dirty) return errors;
      !this.$v.imagenTec2.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.resultadoParValue.$dirty) return errors;
      !this.$v.resultadoParValue.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.imagenPar.$dirty) return errors;
      !this.$v.imagenPar.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.resultadoPar2Value.$dirty) return errors;
      !this.$v.resultadoPar2Value.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.imagenPar2.$dirty) return errors;
      !this.$v.imagenPar2.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.resultadoPardsDaValue.$dirty) return errors;
      !this.$v.resultadoPardsDaValue.required &&
        errors.push("Item es requerido");
      return errors;
      if (!this.$v.resultadoPardsDvpValue.$dirty) return errors;
      !this.$v.resultadoPardsDvpValue.required &&
        errors.push("Item es requerido");
      return errors;
      if (!this.$v.resultadoPardsDvtValue.$dirty) return errors;
      !this.$v.resultadoPardsDvtValue.required &&
        errors.push("Item es requerido");
      return errors;
      if (!this.$v.imagenPards.$dirty) return errors;
      !this.$v.imagenPards.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.resultadoDsdaValue.$dirty) return errors;
      !this.$v.resultadoDsdaValue.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.imagenDsda.$dirty) return errors;
      !this.$v.imagenDsda.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.resultadoDsdaLschValue.$dirty) return errors;
      !this.$v.resultadoDsdaLschValue.required &&
        errors.push("Item es requerido");
      return errors;
      if (!this.$v.imagenDsdaLsch.$dirty) return errors;
      !this.$v.imagenDsdaLsch.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.resultadoDvpValue.$dirty) return errors;
      !this.$v.resultadoDvpValue.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.imagenDvp.$dirty) return errors;
      !this.$v.imagenDvp.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.resultadoDvtValue.$dirty) return errors;
      !this.$v.resultadoDvtValue.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.imagenDvt.$dirty) return errors;
      !this.$v.imagenDvt.required && errors.push("Item es requerido");
      return errors;
    },

    isDisabled() {
      if (
        this.tipeView == "consulta" ||
        this.tab == "Capacitacion" ||
        this.tab == "Asignacion"
      ) {
        return true;
      }
    },
    isDisabledCap() {
      if (this.tipeView == "consulta") {
        return true;
      }
    },
    isDisabledSel() {
      if (this.tipeView == "modifica" || this.tipeView == "consulta") {
        return true;
      }
    },
    isDisabledRut() {
      if (this.tipeView == "modifica" || this.tipeView == "consulta") {
        return true;
      }
    },
    isDisabledselect() {
      if (
        this.tipeView == "consulta" ||
        this.user == "AGENCIA" ||
        this.tab == "Capacitacion"
      ) {
        return true;
      }
    },
  },
  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },

    loadResultadoTecNuevoModifica() {
      let resuNombre =
        this.documento.resultado_tec !== undefined &&
        this.documento.resultado_tec != null
          ? this.documento.resultado_tec
          : "";
      let resu = [];
      let resulCode = [];
      this.resultadoOpciones.forEach(function (r) {
        resu.push({ descripcion: r.descripcion, id: r.id });
        if (r.descripcion == resuNombre) {
          resulCode.push({ id: r.id });
        }
      });
      this.resultadoTecNuevoSelect = resu;
      this.resultadoTecNuevoValue = resulCode[0];
      return;
    },

    loadResultadoTecDosModifica() {
      let resuNombre =
        this.documento.resultado_tec2 !== undefined &&
        this.documento.resultado_tec2 != null
          ? this.documento.resultado_tec2
          : "";
      let resu = [];
      let resulCode = [];
      this.resultadoOpciones.forEach(function (r) {
        resu.push({ descripcion: r.descripcion, id: r.id });
        if (r.descripcion == resuNombre) {
          resulCode.push({ id: r.id });
        }
      });

      this.resultadoTecDosSelect = resu;
      this.resultadoTecDosNuevoValue = resulCode[0];

      return;
    },

    loadResultadoParModifica() {
      let resuNombre =
        this.documento.resultado_par !== undefined &&
        this.documento.resultado_par != null
          ? this.documento.resultado_par
          : "";
      let resu = [];
      let resulCode = [];
      this.resultadoOpciones.forEach(function (r) {
        resu.push({ descripcion: r.descripcion, id: r.id });
        if (r.descripcion == resuNombre) {
          resulCode.push({ id: r.id });
        }
      });
      this.resultadoParSelect = resu;
      this.resultadoParValue = resulCode[0];

      return;
    },

    loadResultadoPar2Modifica() {
      let resuNombre =
        this.documento.resultado_par2 !== undefined &&
        this.documento.resultado_par2 != null
          ? this.documento.resultado_par2
          : "";
      let resu = [];
      let resulCode = [];
      this.resultadoOpciones.forEach(function (r) {
        resu.push({ descripcion: r.descripcion, id: r.id });
        if (r.descripcion == resuNombre) {
          resulCode.push({ id: r.id });
        }
      });
      this.resultadoPar2Select = resu;
      this.resultadoPar2Value = resulCode[0];

      return;
    },
    loadResultadoPardsDaModifica() {
      let resuNombre =
        this.documento.resultado_pards_da !== undefined &&
        this.documento.resultado_pards_da != null
          ? this.documento.resultado_pards_da
          : "";
      let resu = [];
      let resulCode = [];
      this.resultadoOpciones.forEach(function (r) {
        resu.push({ descripcion: r.descripcion, id: r.id });
        if (r.descripcion == resuNombre) {
          resulCode.push({ id: r.id });
        }
      });
      this.resultadoPardsDaSelect = resu;
      this.resultadoPardsDaValue = resulCode[0];

      return;
    },
    loadResultadoPardsDvpModifica() {
      let resuNombre =
        this.documento.resultado_pards_dvp !== undefined &&
        this.documento.resultado_pards_dvp != null
          ? this.documento.resultado_pards_dvp
          : "";
      let resu = [];
      let resulCode = [];
      this.resultadoOpciones.forEach(function (r) {
        resu.push({ descripcion: r.descripcion, id: r.id });
        if (r.descripcion == resuNombre) {
          resulCode.push({ id: r.id });
        }
      });
      this.resultadoPardsDvpSelect = resu;
      this.resultadoPardsDvpValue = resulCode[0];

      return;
    },
    loadResultadoPardsDvtModifica() {
      let resuNombre =
        this.documento.resultado_pards_dvt !== undefined &&
        this.documento.resultado_pards_dvt != null
          ? this.documento.resultado_pards_dvt
          : "";
      let resu = [];
      let resulCode = [];
      this.resultadoOpciones.forEach(function (r) {
        resu.push({ descripcion: r.descripcion, id: r.id });
        if (r.descripcion == resuNombre) {
          resulCode.push({ id: r.id });
        }
      });
      this.resultadoPardsDvtSelect = resu;
      this.resultadoPardsDvtValue = resulCode[0];

      return;
    },
    loadResultadoDsdaModifica() {
      let resuNombre =
        this.documento.resultado_dsda !== undefined &&
        this.documento.resultado_dsda != null
          ? this.documento.resultado_dsda
          : "";
      let resu = [];
      let resulCode = [];
      this.resultadoOpciones.forEach(function (r) {
        resu.push({ descripcion: r.descripcion, id: r.id });
        if (r.descripcion == resuNombre) {
          resulCode.push({ id: r.id });
        }
      });
      this.resultadoDsdaSelect = resu;
      this.resultadoDsdaValue = resulCode[0];

      return;
    },
    loadResultadoDsdaLschModifica() {
      let resuNombre =
        this.documento.resultado_dsda_lsch !== undefined &&
        this.documento.resultado_dsda_lsch != null
          ? this.documento.resultado_dsda_lsch
          : "";
      let resu = [];
      let resulCode = [];
      this.resultadoOpciones.forEach(function (r) {
        resu.push({ descripcion: r.descripcion, id: r.id });
        if (r.descripcion == resuNombre) {
          resulCode.push({ id: r.id });
        }
      });
      this.resultadoDsdaLschSelect = resu;
      this.resultadoDsdaLschValue = resulCode[0];

      return;
    },
    loadResultadoDvpModifica() {
      let resuNombre =
        this.documento.resultado_dvp !== undefined &&
        this.documento.resultado_dvp != null
          ? this.documento.resultado_dvp
          : "";
      let resu = [];
      let resulCode = [];
      this.resultadoOpciones.forEach(function (r) {
        resu.push({ descripcion: r.descripcion, id: r.id });
        if (r.descripcion == resuNombre) {
          resulCode.push({ id: r.id });
        }
      });
      this.resultadoDvpSelect = resu;
      this.resultadoDvpValue = resulCode[0];

      return;
    },
    loadResultadoDvtModifica() {
      let resuNombre =
        this.documento.resultado_dvt !== undefined &&
        this.documento.resultado_dvt != null
          ? this.documento.resultado_dvt
          : "";
      let resu = [];
      let resulCode = [];
      this.resultadoOpciones.forEach(function (r) {
        resu.push({ descripcion: r.descripcion, id: r.id });
        if (r.descripcion == resuNombre) {
          resulCode.push({ id: r.id });
        }
      });
      this.resultadoDvtSelect = resu;
      this.resultadoDvtValue = resulCode[0];

      return;
    },

    loadOpcionesFijas() {
      this.loadResultadoTecNuevoModifica();
      this.loadResultadoTecDosModifica();
      this.loadResultadoParModifica();
      this.loadResultadoPar2Modifica();
      this.loadResultadoPardsDaModifica();
      this.loadResultadoPardsDvpModifica();
      this.loadResultadoPardsDvtModifica();
      this.loadResultadoDsdaModifica();
      this.loadResultadoDsdaLschModifica();
      this.loadResultadoDvpModifica();
      this.loadResultadoDvtModifica();
    },
    async loadDocumentos(id) {
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/candidatos/docsCandidato/" + idContrato + "/" + id)
        .then((response) => {
          return response.data;
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadDataDocumentos(id) {
      this.loading = true;
      this.itemsDocs = await this.loadDocumentos(id);
      this.loading = false;
      if (this.itemsDocs.length > 0) {
      }
    },
    async downloadFile(id, filename) {
      return await axios
        .get("candidatos/downloadCV/" + id + "/" + this.contratoId, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    openDeleteDialog() {
      this.dialogGrid = true;
    },
    openSeleccion(id, code) {
      this.centrosId = id;
      this.codeCentro = code;
      this.dialogGrid = false;
    },
    async loadCentrosFilter() {
      let subTab = this.$store.getters.subTabSelectedStored;
      let proceso = this.$store.getters.proSelectedStored;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        comuna:
          this.comunaValue && this.comunaValue != null
            ? this.comunaValue
            : null,
        estadoCentro:
          this.estadoValue && this.estadoValue != null
            ? this.estadoValue
            : null,
        proceso: proceso,
        idContrato: idContrato,
        tipoCentro: {
          descripcion: subTab,
        },
      };
      return await axios
        .post("/centro/filters", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    loadRegionSelect() {
      let reg = [];
      this.itemsCentro.forEach(function (c) {
        let index = reg.findIndex((x) => x.region == c.region.nombre);
        if (index === -1) {
          reg.push(c.region.nombre);
        }
      });
      this.regionCentroSelect = reg;
    },

    loadComunaSelect() {
      let com = [];
      this.itemsCentro.forEach(function (c) {
        let index = com.findIndex((x) => x.comuna == c.comuna.nombre);
        if (index === -1) {
          com.push(c.comuna.nombre);
        }
      });
      this.comunaCentroSelect = com;
    },
    loadEstadoSelect() {
      let est = [];
      this.itemsCentro.forEach(function (c) {
        if (c.estadoCentro != null) {
          let index = est.findIndex(
            (x) => x.estadoCentro == c.estadoCentro.descripcion
          );
          if (index === -1) {
            est.push(c.estadoCentro.descripcion);
          }
        }
      });
      this.estadoSelect = est;
    },
    async loadDataCentros() {
      this.loading = true;
      this.itemsCentro = await this.loadCentrosFilter();
      this.loading = false;
      if (this.itemsCentro.length > 0) {
        this.loadRegionSelect();
        this.loadComunaSelect();
        this.loadEstadoSelect();
      }
    },
    filterCenter() {
      this.filter = true;
      this.loadDataCentros();
    },
    clear() {
      this.regionValue = "";
      this.comunaValue = "";
      this.estadoValue = "";
      this.loadDataCentros();
    },
    getRegionName(regionId) {
      let encontrar = this.regionesSelect.find(function (x) {
        return x.code == regionId;
      });
      return encontrar.codigoReg;
    },
    getComunaName(comunaId) {
      let encontrar = this.comunasSelect.find(function (x) {
        return x.code == comunaId;
      });
      return encontrar.codigoCom;
    },
    dvRut() {
      let f = this.formateaRut(this.rut);
      if (f == undefined) {
        this.rut = this.rut;
      } else {
        this.rut = f;
      }
    },
    checkRut() {
      let v = this.validaRut(this.rut);

      if (v === false) {
        return console.log("false");
      } else {
        //esto es para hacer algun tipo de validacion
        this.dv = obtenerDv(this.rut);
        return console.log("verdadero");
      }
    },
    submit() {
      this.$v.$touch();
    },
    async loadData() {
      // this.id = this.$route.params.id;
      this.documento = await this.loadCandidatos();
      this.nombre = this.documento.nombre;
      this.apellido = this.documento.apellido;
      this.apellido1 = this.documento.apellido1;
      this.dv = this.documento.dv;
      this.rut = this.documento.rut + "-" + this.dv;
      this.fono = this.documento.telefono;
      this.email = this.documento.email;
      this.fecha_nacimiento = this.documento.fecha_nacimiento;
      this.loadDataRoles();
      this.idRol = this.documento.rolCapId.id;

      this.forma_capValue = this.documento.tipoMatricula;
      this.loadSelect();
      //this.perfilValue = this.documento.perfil

      this.regionValue = this.documento.region;
      if (this.regionValue == null) {
        this.regionValue = "";
      }
      this.regionesSelect = [this.regionValue];

      this.comunaValue = this.documento.comuna;
      if (this.comunaValue == null) {
        this.comunaValue = "";
      }
      this.comunasSelect = [this.comunaValue];

      this.loadResultadoTecSelect();
      this.loadComplementarioSelect();
      this.loadLschCapSelect();
      this.loadResultadoCapSelect();
      this.loadDvpCapacitadoSelect();
      this.loadSistemaBraSelect();
      this.loadlengOralCapSelect();
      this.loadDataRelatores();

      if (
        this.documento.relatores == null ||
        this.documento.relatores === undefined ||
        this.documento.relatores == ""
      ) {
        this.rutRelatoresValue = { rut: null, code: null };
      } else {
        this.rutRelatoresValue = {
          rut: this.documento.relatores.rut + "-" + this.documento.relatores.dv,
          code:
            this.documento.relatores.rut +
            "," +
            this.documento.relatores.dv +
            "," +
            this.documento.relatores.tipoCapacitacion,
        };
      }

      if (
        this.documento.centros == null ||
        this.documento.centros === undefined ||
        this.documento.centros == ""
      ) {
        this.codeCentro = null;
      } else {
        this.codeCentro = this.documento.centros.codCentro;
      }

      //if (this.puntajeParcial=== undefined || this.puntajeParcial == null) {
      //  this.puntajeParcial= "";
      // } else {
      this.puntajeParcial = this.documento.ptje_par_cap;
      // }

      //if (this.puntajeDvp === undefined || this.puntajeDvp == null) {
      //   this.puntajeDvp = "";
      // } else {
      this.puntajeDvp = this.documento.ptje_ds_dvp_cap;
      // }

      // if (this.puntajeDvt === undefined || this.puntajeDvt == null) {
      //  this.puntajeDvt = "";
      //} else {
      this.puntajeDvt = this.documento.ptje_ds_dvt_cap;
      // }

      // if (this.puntajeDds === undefined || this.puntajeDds == null) {
      //  this.puntajeDds = "";
      // } else {
      this.puntajeDds = this.documento.ptje_ds_da_cap;
      // }
      //====================================CAMPOS NUEVOS
      this.imagenTec = this.documento.imagen_tec;
      if (this.tipeView == "consulta") {
        this.resultadoTecNuevoValue = this.documento.resultado_tec;
        if (this.resultadoTecNuevoValue == null) {
          this.resultadoTecNuevoValue = "";
        }
        this.resultadoTecNuevoSelect = [this.resultadoTecNuevoValue];
        this.resultadoTecDosNuevoValue = this.documento.resultado_tec2;
        if (this.resultadoTecDosNuevoValue == null) {
          this.resultadoTecDosNuevoValue = "";
        }
        this.resultadoTecDosSelect = [this.resultadoTecDosNuevoValue];

        this.resultadoParValue = this.documento.resultado_par;
        if (this.resultadoParValue == null) {
          this.resultadoParValue = "";
        }
        this.resultadoParSelect = [this.resultadoParValue];

        this.resultadoPar2Value = this.documento.resultado_par2;
        if (this.resultadoParValue == null) {
          this.resultadoPar2Value = "";
        }
        this.resultadoPar2Select = [this.resultadoPar2Value];

        this.resultadoPardsDaValue = this.documento.resultado_pards_da;
        if (this.resultadoPardsDaValue == null) {
          this.resultadoPardsDaValue = "";
        }
        this.resultadoPardsDaSelect = [this.resultadoPardsDaValue];

        this.resultadoPardsDvpValue = this.documento.resultado_pards_dvp;
        if (this.resultadoPardsDvpValue == null) {
          this.resultadoPardsDvpValue = "";
        }
        this.resultadoPardsDvpSelect = [this.resultadoPardsDvpValue];

        this.resultadoPardsDvtValue = this.documento.resultado_pards_dvt;
        if (this.resultadoPardsDvtValue == null) {
          this.resultadoPardsDvtValue = "";
        }
        this.resultadoPardsDvtSelect = [this.resultadoPardsDvtValue];

        this.resultadoDsdaValue = this.documento.resultado_dsda;
        if (this.resultadoDsdaValue == null) {
          this.resultadoDsdaValue = "";
        }
        this.resultadoDsdaSelect = [this.resultadoDsdaValue];

        this.resultadoDsdaLschValue = this.documento.resultado_dsda_lsch;
        if (this.resultadoDsdaLschValue == null) {
          this.resultadoDsdaLschValue = "";
        }
        this.resultadoDsdaLschSelect = [this.resultadoDsdaLschValue];

        this.resultadoDvpValue = this.documento.resultado_dvp;
        if (this.resultadoDvpValue == null) {
          this.resultadoDvpValue = "";
        }
        this.resultadoDvpSelect = [this.resultadoDvpValue];

        this.resultadoDvtValue = this.documento.resultado_dvt;
        if (this.resultadoDvtValue == null) {
          this.resultadoDvtValue = "";
        }
        this.resultadoDvtSelect = [this.resultadoDvtValue];
      }

      if (this.tipeView == "modifica") {
        this.loadOpcionesFijas();
      }

      this.imagenTec2 = this.documento.imagen_tec2;
      this.imagenPar = this.documento.imagen_par;
      this.imagenPar2 = this.documento.imagen_par2;
      this.imagenPards = this.documento.imagen_pards;
      this.ImagenDsda = this.documento.imagen_dsda;
      this.imagenDsdaLsch = this.documento.imagen_dsda_lsch;
      this.imagenDvp = this.documento.imagen_dvp;
      this.imagenDvt = this.documento.imagen_dvt;
    },
    async loadRoles() {
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/candidatos/rolesCapacitacion/" + idContrato)
        .then((response) => {
          return response.data;
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadDataRoles() {
      let rolCode =
        this.documento.rolCapId !== undefined && this.documento.rolCapId != null
          ? this.documento.rolCapId.id
          : "";
      let rolName =
        this.documento.rolCapId !== undefined && this.documento.rolCapId != null
          ? this.documento.rolCapId.descripcion
          : "";
      this.genRoles = await this.loadRoles();
      let roles = [];
      this.genRoles.forEach(function (r) {
        roles.push({ nombre: r.descripcion, code: r.id });
      });

      this.rolesSelect = roles;
      this.rolesValue = rolCode;
      return;
    },
    async loadDataRelatores() {
      this.genRelatores = await this.loadRelatores();
      let re = [];
      this.genRelatores.forEach(function (r) {
        re.push({
          rut: r.rut + "-" + r.dv,
          code: r.rut + "," + r.dv + "," + r.tipoCapacitacion,
        });
      });
      this.rutRelatoresSelect = re;
      //this.rutRelatoresValue = ;
    },
    async loadRelatores() {
      let idContrato = this.$store.getters.contratoStored;
      //let idRol = this.documento.rolCapId.id;
      return await axios
        .get("/relatores/findByIdContract/" + idContrato + "/" + this.idRol)
        .then((response) => {
          return response.data;
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    // loadTipoSelect() {

    //     let forma_cap = this.documento.tipoMatricula!=null ? this.documento.tipoMatricula :''
    //     if (this.tipeView=="consulta" || this.tipeView=="modifica" ) {
    //       this.forma_capValue = forma_cap
    //     this.forma_capSelect = [this.forma_capValue]
    //      }
    //     else if (this.tipeView=="modifica" || this.tipeView=="crear") {
    //       this.forma_capSelect = ["ON-LINE", "PRESENCIAL"];
    //        this.forma_capValue = forma_cap
    //      }
    // },

    loadSelect() {
      let perfil = this.documento.perfil != null ? this.documento.perfil : "";
      if (this.tipeView == "crear") {
        this.perfilSelect = ["SI", "NO"];
        this.perfilValue = perfil;
      } else {
        this.perfilValue = perfil;
        this.perfilSelect = [this.perfilValue];
      }
    },
    loadResultadoTecSelect() {
      let resultado =
        this.documento.result_tec_cap != null
          ? this.documento.result_tec_cap
          : "";
      if (this.tipeView == "consulta") {
        this.resultadoTecValue = resultado;
        this.resultadoTecSelect = [this.resultadoTecValue];
      } else if (this.tipeView == "modifica" || this.tipeView == "crear") {
        this.resultadoTecSelect = ["IDÓNEO", "NO IDÓNEO", "OBSERVADO"];
        this.resultadoTecValue = resultado;
      }
    },
    loadComplementarioSelect() {
      let complementario =
        this.documento.result_tec_medio_complement != null
          ? this.documento.result_tec_medio_complement
          : "";
      if (this.tipeView == "consulta") {
        this.complementarioValue = complementario;
        this.complementarioSelect = [this.complementarioValue];
      } else if (this.tipeView == "modifica" || this.tipeView == "crear") {
        this.complementarioSelect = ["APROBADO", "RECHAZADO"];
        this.complementarioValue = complementario;
      }
    },
    loadLschCapSelect() {
      let lsch =
        this.documento.ls_ch_cap != null ? this.documento.ls_ch_cap : "";
      if (this.tipeView == "consulta") {
        this.lschCapValue = lsch;
        this.lschCapSelect = [this.lschCapValue];
      } else if (this.tipeView == "modifica" || this.tipeView == "crear") {
        this.lschCapSelect = ["SI", "NO"];
        this.lschCapValue = lsch;
      }
    },
    loadlengOralCapSelect() {
      let lengOralCap =
        this.documento.len_oral_cap != null ? this.documento.len_oral_cap : "";
      if (this.tipeView == "consulta") {
        this.lengOralCapValue = lengOralCap;
        this.lengOralCapSelect = [this.lengOralCapValue];
      } else if (this.tipeView == "modifica" || this.tipeView == "crear") {
        this.lengOralCapSelect = ["SI", "NO"];
        this.lengOralCapValue = lengOralCap;
      }
    },
    loadSistemaBraSelect() {
      let sys_braille_cap =
        this.documento.sys_braille_cap != null
          ? this.documento.sys_braille_cap
          : "";
      if (this.tipeView == "consulta") {
        this.sistemaBrailleValue = sys_braille_cap;
        this.sistemaBrailleSelect = [this.sistemaBrailleValue];
      } else if (this.tipeView == "modifica" || this.tipeView == "crear") {
        this.sistemaBrailleSelect = ["SI", "NO"];
        this.sistemaBrailleValue = sys_braille_cap;
      }
    },
    loadDvpCapacitadoSelect() {
      let dvp_capacitado =
        this.documento.dvp_capacitado != null
          ? this.documento.dvp_capacitado
          : "";
      if (this.tipeView == "consulta") {
        this.dvpCapacitadoValue = dvp_capacitado;
        this.dvpCapacitadoSelect = [this.dvpCapacitadoValue];
      } else if (this.tipeView == "modifica" || this.tipeView == "crear") {
        this.dvpCapacitadoSelect = ["SI", "NO"];
        this.dvpCapacitadoValue = dvp_capacitado;
      }
    },
    loadResultadoCapSelect() {
      let cap_apto =
        this.documento.cap_apto != null ? this.documento.cap_apto : "";
      if (this.tipeView == "consulta") {
        this.resultadoCapValue = cap_apto;
        this.resultadoCapSelect = [this.resultadoCapValue];
      } else if (this.tipeView == "modifica" || this.tipeView == "crear") {
        this.resultadoCapSelect = ["APROBADO", "RECHAZADO"];
        this.resultadoCapValue = cap_apto;
      }
    },
    async loadCandidatos() {
      let idContrato = this.$store.getters.contratoStored;
      let idCandidato = this.id;

      return await axios
        .get("/candidatos/" + idCandidato + "/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    back() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoAplicacion",
        });
      }, 1000);
    },
    save() {
      if (this.tipeView == "crear") {
        this.saveCandidatos();
      } else if (this.tipeView == "modifica" && this.tab == "Reclutados") {
        this.editCandidatos();
      } else {
        this.editCapacitacion();
      }
    },
    fechaAnterior() {
      let fechaHoy = new Date();
      let fechaAyer = fechaHoy.setDate(fechaHoy.getDate() - 1);
      let formatoAyer = new Date(fechaAyer).toISOString().substr(0, 10);
      this.fecha_nacimiento = formatoAyer;
    },
    saveCandidatos() {
      let idContrato = this.$store.getters.contratoStored;
      let base64EncodedStr = this.base64Value;
      let dv = this.obtenerDv(this.rut);
      let rut = this.obtenerSoloRut(this.rut);
      let v = this.validaRut(this.rut);

      //  if (v == false) {
      //    window.getApp.$emit("ERROR_RUT");
      //     this.location.reload();
      //    } else {
      this.body = {
        idContrato: idContrato,
        rut: rut,
        dv: dv,
        nombre: this.nombre,
        apellido1: this.apellido1,
        apellido: this.apellido,
        region: { codigo: this.getRegionName(this.regionValue) },
        comuna: { codigo: this.getComunaName(this.comunaValue) },
        email: this.email,
        telefono: this.fono,
        rol: this.rolesValue,
        tipoMatricula: this.forma_capValue,
        perfil: this.perfilValue,
        asunto: this.asuntoDocumento,
        filename: this.filenameValue,
        documentoCV: base64EncodedStr,
        fecha_nacimiento: this.formatoFecha(this.fecha_nacimiento),

        //==========nuevos campos

        imagen_tec: null, //  this.imagenTec,
        docimagen_tec: null,
        resultado_tec: this.resultadoTecValue,
        resultado_tec2: this.resultadoTecDosNuevoValue,
        imagen_tec2: null, //  this.imagenTec2,
        docimagen_tec2: null,
        resultado_par: this.resultadoParValue,
        imagen_par: null, //  this.imagenPar,
        docimagen_par: null,
        resultado_par2: this.resultadoPar2Value,
        imagen_par2: null, // this.imagenPar2,
        docimagen_par2: null,
        resultado_pards_da: this.resultadoPardsDaValue,
        resultado_pards_dvp: this.resultadoPardsDvpValue,
        resultado_pards_dvt: this.resultadoPardsDvtValue,
        imagen_pards: null, // this.imagenPards,
        docimagen_pards: null,
        resultado_dsda: this.resultadoDsdaValue,
        imagen_dsda: null, // this.imagenDsda,
        docimagen_dsda: null,
        resultado_dsda_lsch: this.resultadoDsdaLschValue,
        imagen_dsda_lsch: null, // this.imagenDsdaLsch,
        docimagen_dsda_lsch: null,
        resultado_dvp: this.resultadoDvpValue,
        imagen_dvp: null, //this.imagenDvp,
        docimagen_dvp: null,
        resultado_dvt: this.resultadoDvtValue,
        imagen_dvt: null, // this.imagenDvt,
        docimagen_dvt: null,
      };

      //}
      axios
        .post("/candidatos/newCandidato", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch((error) => {
          if (error == undefined || error == null) {
            console.log(error.response.data.defaultMessage);
          } else if (error.response.status == 400) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          } else if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION_BACK");
          }
        });
    },
    editCandidatos() {
      let idContrato = this.$store.getters.contratoStored;
      let base64EncodedStr = this.base64Value;

      this.body = {
        id: this.id,
        idContrato: idContrato,
        nombre: this.nombre,
        apellido1: this.apellido1,
        apellido: this.apellido,
        telefono: this.fono,
        rol: this.rolesValue,
        asunto:
          this.asuntoDocumento && this.asuntoDocumento != null
            ? this.asuntoDocumento
            : null,
        filename:
          this.filenameValue && this.filenameValue != null
            ? this.filenameValue
            : null,
        documentoCV:
          base64EncodedStr && base64EncodedStr != null
            ? base64EncodedStr
            : null,
      };

      axios
        .put("candidatos/updateCandidato", this.body)
        .then((response) => {
          this.resp = response.data;
          console.log(response.data);
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
        });
    },

    editCapacitacion(e) {
      //this.$v.$touch();
      let relatorInfo = [];
      // SE COMENTA PORQUE NO SE ENTIENDE FUNCION,
      // PARA EXPLICACION DE FUNCIONAMIENTO AL IGUAL QUE LA VARIABLE DE ENTRADA,
      // TAMBIEN SE ESTA REDIRECCIONANDO MAL AL GUARDAR SE VA A APLICACION

      relatorInfo = this.rutRelatoresValue.split(",");

      let idContrato = this.$store.getters.contratoStored;
      let v = this.validaRut(this.rut);
      let idCandidato = this.id;
      let lsch;

      if (this.lschCapValue != "SI" && this.lschCapValue != "NO") {
        lsch == null;
      } else {
        lsch == this.lschCapValue;
      }

      this.body = {
        id: idCandidato,
        idContrato: idContrato,
        // ========== se comenta por errorel api call
        rutRelator: relatorInfo[0],
        dvRelator: relatorInfo[1],
        idCapacitacionRelator: relatorInfo[2],
        // "rutRelator":"12122731",
        // "dvRelator":"2",
        // "idCapacitacionRelator":2,

        centrosId: this.centrosId,
        capacitacion: "Seleccionado",
        result_tec_cap: this.resultadoTecValue,
        result_tec_medio_complement: this.complementarioValue,
        ptje_par_cap: this.puntajeParcial,
        ptje_ds_da_cap: this.puntajeDds,
        ptje_ds_dvp_cap: this.puntajeDvp,
        ptje_ds_dvt_cap: this.puntajeDvt,
        // ls_ch_cap: lsch,
        // len_oral_cap: this.lengOralCapValue,
        // sys_braille_cap: this.sistemaBrailleValue,
        // dvp_capacitado: this.dvpCapacitadoValue,
        cap_apto: this.resultadoCapValue,
        // //=====================================nuevos campos
        imagen_tec: this.imagenTec,
        imagen_tec: this.imagenTec,
        resultado_tec: this.resultadoTecNuevoValue,
        resultado_tec2: this.resultadoTecDosNuevoValue,
        imagen_tec2: this.imagenTec2,
        resultado_par: this.resultadoParValue,
        imagen_par: this.imagenPar,
        resultado_par2: this.resultadoPar2Value,
        imagen_par2: this.imagenPar2,
        resultado_pards_da: this.resultadoPardsDaValue,
        resultado_pards_dvp: this.resultadoPardsDvpValue,
        resultado_pards_dvt: this.resultadoPardsDvtValue,
        imagen_pards: this.imagenPards,
        resultado_dsda: this.resultadoDsdaValue,
        imagen_dsda: this.imagenDsda,
        resultado_dsda_lsch: this.resultadoDsdaLschValue,
        imagen_dsda_lsch: this.imagenDsdaLsch,
        resultado_dvp: this.resultadoDvpValue,
        imagen_dvp: this.imagenDvp,
        resultado_dvt: this.resultadoDvtValue,
        imagen_dvt: this.imagenDvt,
      };

      axios
        .put("candidatos/updateApto", this.body)
        .then((response) => {
          this.resp = response.data;
          console.log(response.data);
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
        });
    },
  },
};
</script>
